import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Host1, HttpHeaderToken } from '../general/variables';
import { Persona } from '../models/Persona';

@Injectable({
  providedIn: 'root'
})

export class PersonaService {

  constructor(protected http: HttpClient) { }

  // tslint:disable-next-line: ban-types
  url: String = `${Host1}`;
  obtenerPersonaRuc( tipoDocumento: string, dscRUC: string) {
    const data = {"ruc":dscRUC };
    return this.http.post<Persona>(`${this.url}/persona/ruc`, data, HttpHeaderToken());
  }
  obtenerPersona( tipoDocumento: string, dscDNI: string) {
    if ( tipoDocumento === '1') {
      tipoDocumento = 'N';
    } else if ( tipoDocumento === '3') {
      tipoDocumento = 'J';
    }

    return this.http.get<Persona>(`${this.url}/persona/${tipoDocumento}/${dscDNI}`, HttpHeaderToken());
  }

  obtenerPersonaDni( tipoDocumento: string, madre: string,  dscDNI: string) {
    const data = {"dni":dscDNI, "materno":madre};
    return this.http.post<Persona>(`${this.url}/persona/dni`, data, HttpHeaderToken());
  }

}
